// 기능으로 쓰이는 클래스 이름 그냥 스트링으로 구현X -> 여기에 적고 export해서 쓸 것
export const 무료체험_시나리오_스와이퍼 = 'scenario-swiper'
export const 무료체험_시나리오_스와이퍼_슬라이드 = 'scenario-swiper-slide'
export const PORTAL_DEFAULT_ID = 'webthflat-portal'

export const 내학습지_필터_학습지만들기 = 'my-worksheet-make-worksheet'
export const 내학습지_학습지없음_학습지만들기_버튼 = 'my-worksheet-empty-make-worksheet'
export const 수업_학생_학습지_채점 = 'student-worksheet-scoring-button'
export const 수업_학생_학습지_아이템 = 'student-worksheet-item'
export const 보고서만들기버튼 = 'create-report-button'
export const 단원기간별취약유형관리 = 'weak-worksheet-manage'
export const DATE_PICKER_COMPONENT = 'mathflat-datepicker'
export const CALENDAR_COMPONENT = 'mathflat-calendar'
export const TABLE_SCROLL_BODY_CLASSNAME = 'table-scroll-body'
export const MATHFLAT_MODAL_PORTAL = 'mathflat-modal-portal'
export const MATHFLAT_GLOBAL_LOADER = 'mathflat-global-loader'
